export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";

export const GET_LEAD_SOURCES = "GET_LEAD_SOURCES";
export const GET_LEAD_SOURCES_SUCCESS = "GET_LEAD_SOURCES_SUCCESS";
export const GET_LEAD_SOURCES_FAILURE = "GET_LEAD_SOURCES_FAILURE";

export const CREATE_LEAD_SOURCE = "CREATE_LEAD_SOURCE";
export const CREATE_LEAD_SOURCE_SUCCESS = "CREATE_LEAD_SOURCE_SUCCESS";
export const CREATE_LEAD_SOURCE_FAILURE = "CREATE_LEAD_SOURCE_FAILURE";

export const UPDATE_LEAD_SOURCE = "UPDATE_LEAD_SOURCE";
export const UPDATE_LEAD_SOURCE_SUCCESS = "UPDATE_LEAD_SOURCE_SUCCESS";
export const UPDATE_LEAD_SOURCE_FAILURE = "UPDATE_LEAD_SOURCE_FAILURE";

export const DELETE_LEAD_SOURCE = "DELETE_LEAD_SOURCE";
export const DELETE_LEAD_SOURCE_SUCCESS = "DELETE_LEAD_SOURCE_SUCCESS";
export const DELETE_LEAD_SOURCE_FAILURE = "DELETE_LEAD_SOURCE_FAILURE";

export const UPDATE_LEAD_SOURCE_STATUS = "UPDATE_LEAD_SOURCE_STATUS";
export const UPDATE_LEAD_SOURCE_STATUS_SUCCESS = "UPDATE_LEAD_SOURCE_STATUS_SUCCESS";
export const UPDATE_LEAD_SOURCE_STATUS_FAILURE = "UPDATE_LEAD_SOURCE_STATUS_FAILURE";
